<template>
	<ui-panel @click.native="goAccounts" class="panel-custom" v-if="computeActiveSchool">
		<div class="user-info-container">
			
          <avatar :src="computeAvatarScr" class="avatar-small"/>
          <div class="text">
			<div class="bold">{{$t('language.full_name')}}</div>
			<div class="val">{{appSettings.fullname}} ({{$t(computeUserLevelToName)}})</div>
			
			<div class="bold">{{$t('language.loggedin_on')}}</div>
			<div class="val">{{school.url}}</div>

			<div class="bold">{{$t('language.user_name')}}</div>
			<div class="val">{{school.username}}</div>
          </div>
        </div>
	</ui-panel>
</template>

<script>
import Avatar from './Avatar.vue';
import { mapState } from 'vuex';
import UiPanel from './UiPanel.vue';

export default {
  name: 'user-info',
  props:{ 
  },
  data:function(){
    return {
		school:{}
    }
  },
  components:{
	Avatar,
	UiPanel,
  },
  methods:{
	goAccounts(){
		this.$router.push({path:"/settings/"})
	}
  },
  computed:{
	...mapState(['appSettings','user_schools']),
	computeAvatarScr(){
		var timestamp="?ts="+new Date().getTime();
		return this.appSettings.avatar+timestamp;
	},
	computeActiveSchool(){
		// eslint-disable-next-line
		this.school = this.user_schools.find(school => school.active === 1);
		if(this.school){
			return true
		}
		return false;
	},
	computeUserLevelToName(){
		if(this.appSettings.user_level==1){
			return 'language.role_parent'
		}
		if(this.appSettings.user_level==2){
			return 'language.role_teacher'
		}
		if(this.appSettings.user_level==3){
			return 'language.role_admin'
		}
		if(this.appSettings.user_level==4){
			return 'language.role_student'
		}
		return 'not logged in';
	}
   
  },
  mounted:function(){
	
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.panel-custom{
	display:inline-block;
	cursor:pointer;
	border-color:#DDDDDD;
	overflow:hidden;
}

.user-info-container{
	font-size:.75em;
	display:inline-block;
	
}

.avatar-small{
	width:40px;
	height:40px;
	margin:0;
	margin-right:10px;
} 
.text{
	flex:1;
}
.bold{
	font-weight:bold;
}
.val{
	padding-bottom:4px;
}
</style>

